import { useState, useEffect } from "react";
import "./App.css";
import { Route, Routes, useLocation } from "react-router-dom";
import LogoSplash from "./components/logoSplash";
import Layout from "./components/layout";
import Home from "./pages/Home";
import { AnimatePresence, motion } from "framer-motion";
import LifeCoaching from "./pages/services/lifeCoaching";
import ContactUs from "./pages/contactUs";
import AboutUs from "./pages/aboutUs";
import ScrollToTop from "./components/scrollToTop";
import ThankYou from "./pages/thankYou";
import Retreats from "./pages/Retreats";
import NotFound from "./pages/notFound";

import ServicesModal from "./components/servicesModal";
import Booking from "./pages/Booking";
import Testimonials from "./pages/Testomonials";

export default function App() {
  const location = useLocation();
  const state = location.state;
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => setLoading(false), 2000);
    return () => clearTimeout(timer);
  }, []);

  return (
    <AnimatePresence mode="wait">
      {loading ? (
        <motion.div
          key="splash"
          initial={{ opacity: 1 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0, transition: { duration: 0.8 } }}
        >
          <LogoSplash />
        </motion.div>
      ) : (
        <motion.div
          key="main"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.8 }}
          className="bg-brown w-full min-h-screen text-accentyellow font-sans"
        >
          <ScrollToTop />
          <Routes location={state?.background || location}>
            <Route path="/" element={<Layout />}>
              <Route index element={<Home />} />
              <Route path="/testimonials" element={<Testimonials />} />
              <Route path="/coaching" element={<LifeCoaching />} />
              <Route path="/bookings" element={<Booking />} />
              <Route path="/retreats" element={<Retreats />} />
              <Route path="/contact" element={<ContactUs />} />
              <Route path="/about" element={<AboutUs />} />
              <Route path="/thank-you" element={<ThankYou />} />
              <Route path="*" element={<NotFound />} />
            </Route>
          </Routes>

          {state?.background && (
            <Routes>
              <Route path="/services" element={<ServicesModal />} />
            </Routes>
          )}
        </motion.div>
      )}
    </AnimatePresence>
  );
}
